<selfai-platform-schedules-list
></selfai-platform-schedules-list>
